import Link from '@mui/material/Link';
import { ReactNode } from 'react';
import { TermsModal } from 'src/components/Terms/TermsModal';
import useDialog from 'src/helpers/hooks/useDialog';

interface TermsAndConditionsButtonProps {
  children: ReactNode;
}

const termsAndConditionsButtonStyles = {
  link: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    cursor: 'pointer',
  },
};

export function TermsAndConditionsButton({
  children,
}: TermsAndConditionsButtonProps) {
  const {
    handleOpen: openDialog,
    handleClose: closeDialog,
    open: isDialogOpen,
  } = useDialog();

  return (
    <>
      <Link
        sx={termsAndConditionsButtonStyles.link}
        role="button"
        onClick={openDialog}
        component={'span'}
      >
        {children}
      </Link>
      <TermsModal
        open={isDialogOpen}
        onClose={closeDialog}
        onOpen={openDialog}
        type="Purchase"
      />
    </>
  );
}
